import { Component, OnInit } from '@angular/core';  
import {  ActivatedRoute ,Router} from '@angular/router';
import { AppConfigService } from '../../../../core/config/app-config.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({  
  selector: 'app-docviewer',  
  templateUrl: './docviewer.component.html',  
  styleUrls: ['./docviewer.component.css']  
})  

export class DocviewerComponent implements OnInit {  
  protected fileServiceURLURL = AppConfigService.settings.AppConfig.FILESERVICEURL;
  viewer = 'google';    
  doc:any;
  constructor(private route: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,private router: Router) {
   
    }  
  
  ngOnInit(): void {  
    this.SpinnerService.show();
    var downloadURL = this.route.snapshot.paramMap.get('downloadURL')
    this.doc = this.fileServiceURLURL + downloadURL;
  }  


  contentLoaded() {
    this.SpinnerService.hide();
  }

  downloadUrl()
  {
    
    window.location.href =this.doc
  }
  
}  